import { render, staticRenderFns } from "./AddAffiliatePolicy.vue?vue&type=template&id=2c715a8f&"
import script from "./AddAffiliatePolicy.vue?vue&type=script&lang=js&"
export * from "./AddAffiliatePolicy.vue?vue&type=script&lang=js&"
import style0 from "./AddAffiliatePolicy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports